export default "__VITE_ASSET__1y9x1OPU__"